// Escape html for RichText component
const escapeMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#x27;': '\'',
  '&#x60;': '`',
}
const createEscaper = (map) => {
  const escaper = match => map[match]
  // Regexes for identifying a key that needs to be escaped.
  const source = `(?:${Object.keys(map).join('|')})`
  const testRegexp = RegExp(source)
  const replaceRegexp = RegExp(source, 'g')
  return (string) => {
    const modifiedString = string == null ? '' : string
    return testRegexp.test(modifiedString)
      ? modifiedString.replace(replaceRegexp, escaper)
      : modifiedString
  }
}
export const unescapeHtml = createEscaper(escapeMap)

// Return the current viewport
const breakpoints = {
  small: 480,
  medium: 767,
  large: 960,
  default: 1024,
  XLarge: 1200,
}
const defaultViewPort = 'XXLarge'

const screenWidth = () => Math.max(document.documentElement.clientWidth, window.innerWidth || 0)

const getViewPort = (screenWidth, breakpoints) => {
  let viewport = defaultViewPort
  const w = screenWidth()
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(breakpoints)) {
    if (w <= breakpoints[key]) {
      viewport = key
      break
    }
  }
  return viewport
}
// Return the current viewport
export const getCurrentViewPort = () => getViewPort(screenWidth, breakpoints)

// Return query string as object from the url
export const getObjectFromQueryString = (qString = window.location.search) => {
  if (qString.trim() === '') return {}
  const pairs = qString.slice(1).split('&')
  const result = {}
  // eslint-disable-next-line func-names
  pairs.forEach((pair) => {
    const modifiedPair = pair.split('=')
    result[modifiedPair[0]] = decodeURIComponent(modifiedPair[1] || '')
  })
  return result
}

// Check if query parameter is present in url
export const isQueryParamPresent = (q) => {
  const regex = new RegExp(`[?&]${q}=`)
  return regex.test(window.location.search)
}

// Check is object empty
export const isEmpty = obj => Object.keys(obj).length === 0

// To get cookie value using cookie name
export const getCookieByname = (name) => {
  const re = new RegExp(`${name}=([^;]+)`)
  const value = re.exec(document.cookie)
  return value != null ? unescape(value[1]) : null
}

// Generate  a page name based on the URL, this is used to generate a campaign IDS
export const getPageName = (separator, path) => {
  // eslint-disable-next-line no-param-reassign
  path = path || window.location.pathname
  // eslint-disable-next-line no-param-reassign
  separator = separator || '-'
  const tempPage = path
    .split('/')
    .filter((path) => {
      if (path !== '') return true
      return false
    })
    .join(separator)
  return tempPage || 'hp'
}

// To get header details based on HomeURL
export const getLogoNameByHomeUrl = (homeUrl) => {
  if (homeUrl === '/baby-club') return 'babyClubLogo'
  return 'logo'
}

export const getRequestOriginFromUrl = () => {
  const babyClub = window.location.pathname.split('/')[1] === 'baby-club'
  if (babyClub) return 'btc'
  return 'asda'
}

export const getLogoLinkByHomeUrl = (homeUrl) => {
  if (homeUrl === '/baby-club') return '/baby-club'
  return '/'
}



// WEBPACK FOOTER //
// ./services/utility/index.js